import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { RouteStore } from 'bernie-core';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

import { PropertyStickyBookBar } from '@shared-ui/lodging-property-offers';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { MultiItemStore } from 'stores/multi-item-store';

import { AVAILABILITY_HEADER_REF_NAME } from 'components/infosite/rooms-and-rates/listings-header';
import { parse } from 'query-string';
import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SingleOfferSearchForm } from '../../single-offer-search';
import { START_DATE_REF_NAME } from '../form/field-wrappers';

interface SharedUiPropertyStickyBookBarProps extends SharedUiWrapperProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
  routeStore?: RouteStore;
}

export const StickyBookBarWrapper: React.FC<SharedUiPropertyStickyBookBarProps> = inject(
  'currentHotel',
  'multiItem',
  'routeStore'
)(
  observer(({ inputs, data, currentHotel, multiItem, routeStore }) => {
    const isDateless = currentHotel?.searchCriteria?.isDateless;
    // Used for H+H use case
    const multiItemPlaybackDisplayed = multiItem?.cartInfo?.id;

    const isMktRequest = () =>
      Object.keys(parse(routeStore.search))
        .map(key => key.toLowerCase())
        .filter(key => ['semcid', 'emlcid', 'mdpcid'].includes(key)).length > 0;

    if (!isDateless) {
      if (multiItemPlaybackDisplayed) {
        return null;
      }

      return (
        <PropertyStickyBookBar inputs={inputs} data={data} focusTargetRef={AVAILABILITY_HEADER_REF_NAME}>
          <SingleOfferSearchForm />
        </PropertyStickyBookBar>
      );
    }

    if (isDateless && isMktRequest()) {
      return (
        <Viewport>
          <ViewSmall>
            <React.Fragment />
          </ViewSmall>
          <ViewLarge>
            <PropertyStickyBookBar inputs={inputs} data={data} clickTargetRef={START_DATE_REF_NAME}>
              <SingleOfferSearchForm />
            </PropertyStickyBookBar>
          </ViewLarge>
        </Viewport>
      );
    }

    return (
      <PropertyStickyBookBar inputs={inputs} data={data} clickTargetRef={START_DATE_REF_NAME}>
        <SingleOfferSearchForm />
      </PropertyStickyBookBar>
    );
  })
);

StickyBookBarWrapper.displayName = 'StickyBookBarWrapper';

export const SharedUiStickyBookBarWrapper = withSharedUiPropertyOffers(StickyBookBarWrapper);
